<template>
  <v-content :style="$store.getters.configuration.sceneStyle">
    <canvas id="canvas" :style="canvasStyle"></canvas>
    <!-- <v-btn
      icon
      color="white"
      fab
      dark
      small
      class="button"
      id="add-conponent-button"
      @click="addElementClick"
    >
      <v-icon>add</v-icon>
    </v-btn>-->
    <v-btn
      :disabled="commands.length == 0"
      icon
      color="white"
      fab
      dark
      small
      class="button"
      id="revert-button"
      @click="revert"
      v-tooltip="$t('undo')"
    >
      <v-icon>reply</v-icon>
    </v-btn>
    <v-btn
      icon
      color="white"
      fab
      dark
      small
      class="button"
      id="toggle-fronts-button"
      @click="toggleFronts"
      v-tooltip="$t('toggleFronts')"
    >
      <v-icon>meeting_room</v-icon>
    </v-btn>
    <v-btn
      :disabled="selectedElements.length == 0"
      icon
      color="white"
      fab
      dark
      small
      class="button"
      id="remove-elements-button"
      @click="removeElements"
      v-tooltip="$t('removeElement')"
    >
      <v-icon>delete</v-icon>
    </v-btn>
  </v-content>
</template>
<script>
import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import TemplatesModule from "@/store/modules/templates";
import {
  Vector3,
  Mesh,
  Scene,
  Engine,
  Camera,
  Color3,
  Color4,
  PointLight,
  ArcRotateCamera,
  StandardMaterial,
  AbstractMesh,
  Material,
  HighlightLayer,
  Vector2,
  CubeTexture,
  SceneLoader,
  HemisphericLight,
  PBRMetallicRoughnessMaterial,
  Texture,
  BaseTexture
} from "@babylonjs/core";
import * as BABYLON from "@babylonjs/loaders";
import Cell from "@/models/cell.ts";
import Area from "@/models/area.ts";
import Element from "@/models/element.ts";
import Construction from "@/models/construction.ts";
import ICommand from "@/models/command/ICommand.ts";
import AddElementCommand from "@/models/command/addElementCommand.ts";
import "@babylonjs/loaders";
import { PostProcess } from "@/models/postProcess.ts";
import { ElementType } from "@/models/element";
import RemoveElementsCommand from "@/models/command/removeElementsCommand.ts";
import { positionManager } from "@/models/positionManager.ts";

export default {
  data() {
    return {
      scene: null,
      engine: null,
      camera: null,
      highlightLayer: null,
      highlightColor: new Color3(0, 0, 0),
      boundries: [],
      cells: [],
      areas: [],
      elements: [],
      constructions: [],
      commands: []
    };
  },
  props: ["canvasStyle"],
  computed: {
    canvas() {
      return document.getElementById("canvas");
    },
    apiPath() {
      return `${this.$store.getters.configuration.baseUrl}/api/download/`;
    },
    selectedElements() {
      return this.elements.filter(x => x.isSelected);
    }
  },
  watch: {
    canvasStyle(newStyle) {
      this.engine.resize();
    }
  },
  methods: {
    createScene(engine) {
      const scene = new Scene(engine);
      this.scene = scene;
      scene.clearColor = new Color4(1, 1, 1, 1);
      var hdrTexture = CubeTexture.CreateFromPrefilteredData(
        this.createAssetPath("enviro/creative_enviro.dds"),
        scene
      );
      hdrTexture.gammaSpace = true;
      scene.environmentTexture = hdrTexture;

      this.createCamera();
      const postProcess = new PostProcess(scene);
      postProcess.run();
      this.loadModel();
      this.handleEvents();
      this.highlightLayer = new HighlightLayer("hl1", scene);

      return scene;
    },

    createCamera() {
      const camera = new ArcRotateCamera(
        "Camera",
        0,
        0,
        10,
        new Vector3(0, 0, 10),
        this.scene
      );
      camera.setPosition(new Vector3(0, 0, 200));
      camera.lowerRadiusLimit = 1;
      this.scene.activeCameras.push(camera);
      camera.attachControl(this.canvas);
      camera.fov = 0.87;
      return camera;
    },
    loadModel() {
      // SceneLoader.ImportMesh(
      //   "",
      //   "https://localhost:44332/api/download/",
      //   "Alien.gltf",
      //   this.scene,
      //   (meshes: AbstractMesh[]) => {
      //     console.log(meshes);
      //     meshes.forEach(x => {
      //       x.scaling = new Vector3(100, 100, 100);
      //       this.cells.push(new Cell(0, 0, x as Mesh));
      //     });
      //   },
      //   x => {},
      //   x => {}
      // );

      //test shadow material
      var testmat = new StandardMaterial("testmat", this.scene);
      testmat.diffuseColor = new Color3(0.8, 0.8, 0.8);
      testmat.opacityTexture = new Texture(
        this.createAssetPath("ppio_2_shadow.png"),
        this.scene
      );
      testmat.opacityTexture.coordinatesIndex = 1;
      testmat.opacityTexture.vScale = -1;
      testmat.opacity = 0;

      this.importModel(
        this.scene,
        "korpus2x2.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/H3395.jpg"),
          this.createAssetPath("diffuse/H3395_normal.jpg"),
          this.createAssetPath("korpus_2x2_LIGHT.png")
        )
      );
      this.importModel(
        this.scene,
        "ppio2.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/U606.jpg"),
          this.createAssetPath("diffuse/solid_normal.png"),
          this.createAssetPath("ppio_2_LIGHT.png")
        ),
        "ppio_2_shadow",
        testmat
      );

      // //fronty
      this.importModel(
        this.scene,
        "f_1x1_A2.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/U8101.jpg"),
          this.createAssetPath("diffuse/solid_normal.png"),
          this.createAssetPath("f_1x1_A2Corona_Beauty.png")
        )
      );
      this.importModel(
        this.scene,
        "f_1x1_B1.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/H3395.jpg"),
          this.createAssetPath("diffuse/H3395_normal.jpg"),
          this.createAssetPath("f_1x1_B1Corona_Beauty.png")
        )
      );
      this.importModel(
        this.scene,
        "f_1x05_B2_d.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/U163.jpg"),
          this.createAssetPath("diffuse/solid_normal.png"),
          this.createAssetPath("f_1x05_B2_dCorona_Beauty.png")
        )
      );
      this.importModel(
        this.scene,
        "f_1x05_B2_u.gltf",
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/U163.jpg"),
          this.createAssetPath("diffuse/solid_normal.png"),
          this.createAssetPath("f_1x05_B2_uCorona_Beauty.png")
        )
      );
    },
    importModel(
      scene,
      meshgltf,
      mat,
      shadowmesh,
      shadowmat,
      process = x => {}
    ) {
      SceneLoader.ImportMesh(
        "",
        this.apiPath,
        meshgltf,
        scene,
        meshes => {
          meshes.forEach(mesh => {
            mesh.scaling = new Vector3(1, 1, 1);
            mesh.material = mat;
            if (mesh.name === shadowmesh) {
              mesh.material = shadowmat;
            }
            if (mesh.name.includes("korpus")) {
              const p = mesh.position;
              scene.cameras[0].target = new Vector3(-p.x, p.y, p.z);
            }
          });
          const newElement = this.createElement(meshes);
          process(newElement);
        },
        x => {},
        x => {}
      );
    },
    createElement(meshes) {
      let type = ElementType.BODY;
      if (meshes.some(x => x.name[0] == "f")) type = ElementType.FRONT;
      else if (meshes.some(x => x.name[0] == "p")) type = ElementType.WALL;
      const newElement = new Element(
        new Vector2(0, 0),
        new Vector2(0, 0),
        type,
        meshes
      );
      if (newElement.type == ElementType.BODY) {
        newElement.shape = new Vector2(2, 2);
        positionManager.initialize(newElement);
      }
      this.elements.push(newElement);
      return newElement;
    },
    createAssetPath(localPath) {
      console.log(this.apiPath);
      return `${this.apiPath}${localPath}`;
    },
    createMaterial(scene, diffuse, normal, light) {
      var mat = new PBRMetallicRoughnessMaterial("mat", scene);
      mat.baseColor = new Color3(0.88, 0.88, 0.88);
      mat.metallic = 0.1;
      mat.roughness = 0.4;

      mat.baseTexture = new Texture(diffuse, scene);
      mat.baseTexture.coordinatesIndex = 0;
      mat.baseTexture.uScale = 1.54;
      mat.baseTexture.vScale = 1.54;

      mat.normalTexture = new Texture(normal, scene);
      mat.normalTexture.uScale = 1.54;
      mat.normalTexture.vScale = 1.54;

      /*mat.occlusionTexture=new BABYLON.Texture(diffuse, scene);
    mat.occlusionTexture.coordinatesIndex = 0;
    mat.occlusionTextureStrength=100;
    */

      mat.lightmapTexture = new Texture(light, scene);
      mat.lightmapTexture.coordinatesIndex = 1;
      mat.useLightmapAsShadowmap = true;
      mat.lightmapTexture.vScale = -1;

      mat.backFaceCulling = false;
      return mat;
    },
    changeColors(type, color) {
      const diffuse = `${this.apiPath}diffuse/${color}.jpg`;
      const texture = new Texture(diffuse, this.scene);
      this.elements
        .filter(x => x.type == type)
        .flatMap(x => x.meshes)
        .forEach(x => {
          // płynnie zmniejszyć widoczność
          x.material.baseTexture = texture;
          // płynnie zwiększyć widoczność
        });
    },
    handleEvents() {
      const scene = this.scene;
      const ground = scene.getMeshByName("ground");
      const camera = scene.getCameraByName("Camera");
      const canvas = document.getElementById("canvas");

      const onPointerDown = evt => {
        if (evt.button !== 0) {
          return;
        }
      };

      const onPointerUp = () => {
        let pickedElement;
        const pickInfo = scene.pick(scene.pointerX, scene.pointerY, mesh => {
          const concreteMesh = mesh;
          return (
            this.elements.flatMap(x => x.meshes).find(x => x == concreteMesh) !=
            null
          );
        });

        if (pickInfo == null) {
          return;
        }

        if (pickInfo.hit) {
          const mesh = pickInfo.pickedMesh;
          pickedElement = this.getElementByMesh(mesh);
          console.log(pickedElement);
          if (pickedElement != null && pickedElement.isSelectable)
            if (pickedElement.isSelected) {
              pickedElement.isSelected = false;
              pickedElement.meshes.forEach(x =>
                this.highlightLayer.removeMesh(x)
              );
            } else {
              // this.selectedElements
              //   .flatMap(x => x.meshes)
              //   .forEach(x => this.highlightLayer.removeMesh(x));
              pickedElement.isSelected = true;
              pickedElement.meshes.forEach(x =>
                this.highlightLayer.addMesh(x, this.highlightColor)
              );
            }
        }
      };

      canvas.addEventListener("pointerdown", onPointerDown, false);
      canvas.addEventListener("pointerup", onPointerUp, false);

      scene.onDispose = () => {
        canvas.removeEventListener("pointerdown", onPointerDown);
        canvas.removeEventListener("pointerup", onPointerUp);
      };
    },
    addElementClick() {
      // const command = new AddElementCommand(this);
      // command.execute();
      // this.commands.push(command);
      //console.log(this.areas);
      this.$emit("cellsSelected", this.cells.filter(x => x.isSelected));
    },
    addElement(name, position, size) {
      this.importModel(
        this.scene,
        name,
        this.createMaterial(
          this.scene,
          this.createAssetPath("diffuse/H3395.jpg"),
          this.createAssetPath("diffuse/H3395_normal.jpg"),
          this.createAssetPath("f_1x1_B1Corona_Beauty.png")
        ),
        null,
        null,
        x => {
          x.position = position;
          x.shape = size;
          positionManager.position(x);
        }
      );
    },
    revert() {
      if (this.commands.length > 0) {
        const command = this.commands.pop();
        command.revert();
      }
    },
    getElementByMesh(mesh) {
      return this.elements.find(x => x.meshes.includes(mesh));
    },
    toggleFronts() {
      this.elements
        .filter(x => x.type == ElementType.FRONT)
        .forEach(x => x.toggleVisibility());
    },
    removeElements() {
      const command = new RemoveElementsCommand(
        this.elements,
        this.selectedElements
      );
      this.addCommand(command);
    },
    addCommand(command) {
      this.commands.push(command);
      command.execute();
    }
  },
  mounted() {
    const engine = new Engine(this.canvas, true);
    this.engine = engine;
    const scene = this.createScene(engine);

    engine.runRenderLoop(() => {
      scene.render();
    });

    window.addEventListener("resize", () => {
      engine.resize();
    });

    engine.resize();

    this.addElement("f_1x1_B1.gltf", new Vector2(2, 1), new Vector2(1, 1));
  },
  destroyed() {
    this.engine.stopRenderLoop();
  }

  // public createBlueBox(x: number = 100, y: number = 20) {
  //   const blueBox = Mesh.CreateBox("blue", 20, this.scene);
  //   const blueMat = new StandardMaterial("ground", this.scene!);
  //   blueMat.diffuseColor = new Color3(0.4, 0.4, 0.4);
  //   blueMat.specularColor = new Color3(0.4, 0.4, 0.4);
  //   blueMat.emissiveColor = Color3.Blue();
  //   blueBox.material = blueMat;
  //   blueBox.position.x += x;
  //   blueBox.position.y = y;
  //   return blueBox;
  // }

  // public createShelf(cell1: Cell, cell2: Cell): Mesh {
  //   const shelf = Mesh.CreateBox("shelf", 20, this.scene);
  //   const center = this.getCenter(cell1.mesh.position, cell2.mesh.position);
  //   shelf.position = center;
  //   shelf.scaling.x *= 2;
  //   shelf.scaling.y /= 8;

  //   const blueMat = new StandardMaterial("ground", this.scene);
  //   blueMat.diffuseColor = new Color3(0.4, 0.4, 0.4);
  //   blueMat.specularColor = new Color3(0.4, 0.4, 0.4);
  //   blueMat.emissiveColor = Color3.Black();

  //   shelf.material = blueMat;

  //   return shelf;
  // }

  // public createConstruction(position: Vector2, shape: Vector2): Mesh {
  //   const s = TemplatesModule.selectedTemplate!.template.shape;
  //   const splittedShape = s.split("x");
  //   const height = Number(splittedShape[0]);
  //   const width = Number(splittedShape[1]);

  //   const construction = Mesh.CreateBox("shelf", 20, this.scene);
  //   const first = this.cells[position.x + width * position.y];
  //   const x = position.add(shape);
  //   x.x -= 1;
  //   x.y -= 1;
  //   const second = this.cells[x.x + width * x.y];
  //   const center = this.getCenter(first.mesh.position, second.mesh.position);
  //   construction.position = center;
  //   construction.scaling.x *= shape.x;
  //   construction.scaling.y /= 8;

  //   const blueMat = new StandardMaterial("ground", this.scene!);
  //   blueMat.diffuseColor = new Color3(0.6, 0.6, 0.6);
  //   blueMat.specularColor = new Color3(0.6, 0.6, 0.6);
  //   blueMat.emissiveColor = Color3.Green();

  //   construction.material = blueMat;

  //   return construction;
  // }

  // private getCenter(start: Vector3, end: Vector3) {
  //   const x = (end.x + start.x) / 2;
  //   const y = (end.y + start.y) / 2;
  //   const z = (end.z + start.z) / 2;
  //   return new Vector3(x, y, z);
  // }

  // private getCenter2(start: Vector2, end: Vector2) {
  //   const x = (end.x + start.x) / 2;
  //   const y = (end.y + start.y) / 2;
  //   const z = 0;
  //   return new Vector3(x, y, z);
  // }

  // public createMatrix() {
  //   const shape = TemplatesModule.selectedTemplate!.template.shape;
  //   const splittedShape = shape.split("x");
  //   const height = Number(splittedShape[0]);
  //   const width = Number(splittedShape[1]);

  //   const a = 21;
  //   for (let i = height; i > 0; i--) {
  //     for (let j = width; j > 0; j--) {
  //       const w = j - width / 2.0;
  //       const h = i - height / 2.0;
  //       const box = this.createBlueBox(w * a - 10, h * a - 10);
  //       const cell = new Cell(width - j, height - i, box);
  //       this.cells.push(cell);
  //     }
  //   }
  // }

  //Każdy materiał z 11 głównych musi być możliwy do osobnego definiowania parametrów globalnych, jako parametr wejściowy dostawać będzie tylko Lightmap texture pod konkretny mesh
};
</script>
<style scoped>
#canvas {
  width: 100%;
  height: 100%;
}
.button {
  position: absolute;
  background-color: red;
}
#add-conponent-button {
  right: 16px;
  bottom: 16px;
}
#revert-button {
  left: 16px;
  top: 16px;
}
#toggle-fronts-button {
  left: 16px;
  top: 70px;
}
#remove-elements-button {
  right: 16px;
  bottom: 16px;
}
</style>
